export interface StudiosMapReturnSearch {
  tab: 'studios';
  favourites?: 'true';
  studio?: string;
}

interface StudiosMapHistoryEntry {
  origin: 'discovery-studios';
  returnSearch: StudiosMapReturnSearch;
}

declare module '@tanstack/history' {
  interface HistoryState {
    til?: {
      studiosMap?: unknown;
    };
  }
}

export const createStudiosMapHistoryEntry = (
  returnSearch: StudiosMapReturnSearch
): StudiosMapHistoryEntry => ({
  origin: 'discovery-studios',
  returnSearch,
});

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const getStudiosMapReturnSearch = (state: unknown): StudiosMapReturnSearch | null => {
  if (!isRecord(state) || !isRecord(state.til) || !isRecord(state.til.studiosMap)) return null;

  const entry = state.til.studiosMap;
  if (entry.origin !== 'discovery-studios' || !isRecord(entry.returnSearch)) return null;

  const search = entry.returnSearch;
  if (search.tab !== 'studios') return null;
  if (search.favourites !== undefined && search.favourites !== 'true') return null;
  if (search.studio !== undefined && (typeof search.studio !== 'string' || !search.studio)) {
    return null;
  }

  return {
    tab: 'studios',
    favourites: search.favourites,
    studio: search.studio,
  };
};
